import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const ScheduledPaymentsWrapper = styled.div`
  display: block;
  padding: 0 24px 24px;
`;

export const ScheduledPaymentsLabel = styled.div`
  color: ${(props) => props.theme.color.primary.v600};
  white-space: nowrap;
  margin: 0;
  font-weight: bold;
  font-size: 20px;
  line-height: 24px;
`;

export const ScheduledPaymentsRowItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  min-width: 170px;
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 0px;
  }

  &: > p {
    margin-block-start: 0;
    margin-block-end: 0;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
  }

  @media (min-width: 320px) {
    min-width: 145px;

    &:first-child {
      margin-right: 8px;
    }
  
    &.turn-off-pay:first-child {
      margin-right: 8px;
    }
    
  }

  @media (min-width: 427px) {
    margin-bottom: 0px;
    min-width: 145px;
    
    &:first-child {
      margin-right: 20px;
      min-width: 145px;
    }

    &:last-child {
       margin-bottom 0; 
    }

    &.turn-off-pay:first-child {
      margin-top: 16px;
      min-width: 145px;
    }
  }

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {

    &:first-child {
      margin-right: 40px;
      min-width: 185px;
    }

    &.turn-off-pay:first-child {
      margin-right: 60px;
      min-width: 185px;
    }
  }
`;

export const ScheduledPaymentsRow = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 0;
  margin-bottom: 16px;

  &:last-of-type {
    margin-bottom: 0;
  }
  @media (min-width: 427px) {
    flex-direction: row;
  }
`;

export const Title = styled.h3`
  ${(props) => props.theme.font.heading.v500};
  color: ${(props) => props.theme.color.primary.v400};
  margin: 0px;
  font-size: 14px;
  line-height: 16px;
`;

export const ScheduledPaymentsNote = styled.div`
  color: ${(props) => props.theme.color.neutral.v500};
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  margin: 0;
`;

export const ScheduledPaymentsInfo = styled(ScheduledPaymentsNote)`
  font-weight: ${(props) => props.theme.font.weight.v200};
  font-size: 14px;
  line-height: 20px;
  padding: 4px 0 16px;
  max-width: 630px;
`;
export const NoScheduledPaymentsNote = styled(ScheduledPaymentsNote)`
  font-weight: ${(props) => props.theme.font.weight.v200};
  font-size: 14px;
  line-height: 20px;
  padding: 4px 0 0 0;
  max-width: 630px;
`;

export const CancelPaymentLink = styled.button`
  text-decoration: underline;
  ${(props) => props.theme.font.label.v200};
  color: ${(props) => props.theme.color.primary.v200};
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  &:hover,
  &:focus {
    color: ${(props) => props.theme.color.primary.v400};
    outline-color: transparent;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
  }
`;

export const TurnOffAutoPayLink = styled(Link)`
  text-decoration: underline;
  color: ${(props) => props.theme.color.primary.v200};
  display: flex;
  align-items: center;
  // flex-grow: 1;
  white-space: nowrap;
  cursor: pointer;
  ${(props) => props.theme.font.label.v200};

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
  }
`;

export const LinkWrapper = styled.div`
  display: flex;
  align-items: center;
  color: ${(props) => props.theme.color.neutral.v500};
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
`;

export const SpinnerWrapper = styled.div`
  display: flex;
  min-height: 500px;
`;

export const HR = styled.hr`
  border: 1px solid ${(props) => props.theme.color.neutral.v300};
  width: 100%;
  margin: 0 0 16px 0;
  border-bottom-color: transparent;

  &:last-child {
    display: none;
  }
`;
